<template>
	<section id="sectors">
		<div class="wrapper p-0">
			<div class="video-wrapper" :style="sectionStyle">
				<video autoplay muted loop>
					<source src="/images/city_walkhtrough.mp4" type="video/mp4">
				</video>
			</div>


			<div class="overlay">
				<div class="card" ref="sectorCard">
					<div class="card-body">
						<h2 class="text-center mt-4">Sectors</h2>

						<div class="col-8 offset-2 text-center mb-5">
							<p class="my-4">There are 180,000 unique land tiles within AlphaBatem and they are classified into 25 distinct sectors according to how close they are to AlphaBatem's central hub.</p>
							<router-link to="/map" class="btn btn-secondary btn-sm">View Map</router-link>
						</div>

						<div class="row mt-3">
							<Sector class="col-lg col-sm-6" v-for="(sector,key) in availableSectors" :key="key" :sector="sector"
											:index="key"></Sector>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import Sector from "./Sector";

export default {
	name: "SectorSection",
	components: {Sector},
	props: {
		sectors: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			sectorCard: null
		}
	},
	computed: {
		availableSectors() {

			const avail = [];
			for (const s in this.sectors) {
				if (this.sectors[s].tiles_released)
					avail.push(this.sectors[s])
			}

			return avail
		},
		sectionStyle() {
			if (this.sectorCard !== null) {
				return {minHeight: this.sectorCard.clientHeight + "px"}
			}

			return {minHeight: "700px"}
		},
	},
	mounted() {
		this.sectorCard = this.$refs.sectorCard
	}
}
</script>

<style scoped>
h2 {
	color: white;
}


.video-wrapper {
	min-height: 700px;
}
</style>